import React, { useState, useEffect } from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Collapse, Table } from "antd";

import CreateRepresentative from "./CreateReprentative";
import { util } from '@seims/shared';

const RepresentativeList = ({ partnerSummary, onGetAll, repList=[], isAdd }) => {
  const [expandIconPosition, setExpandIconPosition] = useState("start");
  const [showRepresentativeModal, setShowRepresentativeModal] = useState(false);
  const [representatives, setRepresentatives] = useState([]);
  const [currentRep, setCurrentRep] = useState({});
  const [isMobile, setIsMobile] = useState(false)

  const {Panel} = Collapse;

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    if (!isAdd) {
      getReps();
    }
    else if (repList.length === 0) {
      setRepresentatives(repList);
    }
  }, [repList, isAdd])
  
  const getReps = ()=> {
    setRepresentatives([...repList]);
  }
  
  const handleCancel = ()=> {
    setShowRepresentativeModal(false);
  }

  const onChange = (key) => {
  };

  const addRepresentative =() => {
    setCurrentRep({"uuid": util.generateUUID(), "isAdd": true});
    setShowRepresentativeModal(true);
  }

  const selectedRep = (current)=> {    
    setCurrentRep({...current});
    setShowRepresentativeModal(true);
  }

   const tempStoreRepresentative = (newRep) => {
     const { length } = representatives.filter((c) => c.uuid == newRep.uuid);
     let updatedRepsList = [];     

     if (length === 0) {
       updatedRepsList = [...representatives, newRep];
       setRepresentatives(updatedRepsList);
     } 
     else if (length > 0 && representatives.length > 1) {
       //remove the old item from original list
       const _updRep = [
         ...representatives.filter((item) => item.uuid != newRep.uuid),
       ];

       //copy the newly added item into newly updated list
       updatedRepsList = [..._updRep, newRep];
       setRepresentatives(updatedRepsList);
     } 
     else {
       const empy = [];
       updatedRepsList = [...empy, newRep];
       setRepresentatives(updatedRepsList);
     }
     
     onGetAll(updatedRepsList);
     setShowRepresentativeModal(false);
   };

   const handleResize = () => {
    if (window.innerWidth < 1300) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  const genExtra = () => (   
    <Button key={"1e"} type="primary"
      onClick={(event) => {
        //Call method for opening a dialog
        // If you don't want click extra trigger collapse, you can prevent this:
        addRepresentative();
        event.stopPropagation();

      }}
    >Add</Button>
  );
  const columns = [
    {
      title: "Fullname Email Action",
      key: "1",
      render: (record) => (
        <React.Fragment>
          {record.fullname}
          <br/>
          {record.email}
          <br/><br/>
          <Button key="b1" type="primary" onClick={()=>selectedRep(record)} icon={<EditOutlined />} />&nbsp;
          <Button key="b2" type="danger" icon={<DeleteOutlined />} />
        </React.Fragment>
      ),
      responsive: ["xs"]
    },
    { title: "Name", dataIndex: "fullname", key: "2", responsive: ["sm"] },
    { title: "Email Address", dataIndex: "email", key: "3", responsive: ["sm"] },
    {
      title: "Cellphone No.",
      dataIndex: "cellNumber",
      key: "4",
      responsive: ["sm"]
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "5",
      responsive: ["sm"],
      render: (_,record) => {
        return <Button type="primary" onClick={()=>selectedRep(record)} icon={<EditOutlined />} />;
      },
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "6",
      responsive: ["sm"],
      render: (record) => {
        return <Button type="danger" icon={<DeleteOutlined />} />;
      },
    },
  ];

  const deviceColumns = [
    {
      title: "Fullname Email Action2",
      key: "1",
      render: (record, key, index) => {
         const fullName = record.fullname;
         const email = record.email;
         return (
             <div>
                  <span key={1}> 
                        <h4>Full Name: {fullName}</h4>
                  </span>
                  <span key={2}>
                        <h4>Email: {email}</h4>
                  </span>
                  <span key={3}>
                        <h4>
                          <Button key="3a" type="primary" onClick={()=>selectedRep(record)} icon={<EditOutlined />} />&nbsp;
                          <Button key="3b" type="danger" icon={<DeleteOutlined />} />
                          </h4>
                  </span>
                  <br/>
             </div>
         )
      }
    }
  ];

  return (
    <div>
      <Collapse key="1a" onChange={onChange} expandIconPosition={expandIconPosition}>
        <Panel header={`Representatives (${representatives.length}) items`} key="1p" extra={genExtra()}>
          <Table
            dataSource={representatives}
            columns={isMobile ? deviceColumns : columns}
            bordered
            pagination={{ pageSize: 10 }}
          />
        </Panel>
      </Collapse>
      <CreateRepresentative 
          key="2b"
          onCancel={handleCancel}
          visible={showRepresentativeModal}
          onRepresentativeClick={tempStoreRepresentative}
          partnerSummary={partnerSummary}
          rep={currentRep}
           />
    </div>
  );
};

export default RepresentativeList;
